import { h } from 'preact';
import Section from 'components/bolt/section/section';
import Question from 'components/bolt/expandableTextList/question';
import s from 'components/bolt/expandableTextList/expandableTextList.sss';
import HTML from 'components/core/html/html';
import { joinClasses, sortObjectByOrder, accessNested } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import Store from 'store/store';

export default class ExpandableTextList extends Section {
	constructor(props) {
		super(props);
		this.changeActiveKey = this.changeActiveKey.bind(this);

		this.state = {
			activeKey: null
		};
	}

	componentDidMount() {
		super.componentDidMount();
	}

	onClick(e) {
		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			let page = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (page.includes('/?')) {
				let [pageId, qs] = page.split('/?');
				page = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(page, navOptions);
		}
	}

	changeActiveKey(key) {
		const { activeKey } = this.state;
		if (key !== activeKey) {
			this.setState({ activeKey: key });
			Store.emit('TEXT_LIST_CLICK', key);
		} else {
			this.setState({ activeKey: null });
		}
	}

	render(props) {
		const { id } = props;
		const pageData = accessNested(props, `appData.pages.${id}.data`, {});
		const { title = '', description = '', questions = {} } = pageData;
		const isSection = this.props?.appData?.pages[id].section || false;

		return (
			<div class={joinClasses(s.wrapper, isSection && s.section)} data-section={id}>
				{this.renderBgContent()}
				{title && <HTML tag="h1" markdown content={title} class={joinClasses(s.title, 'h3')} />}
				{description && <HTML tag="h2" markdown content={description} onClickCapture={this.onClick} class={joinClasses(s.description, 'xlarge')} />}
				<div class={s.questions}>
					{sortObjectByOrder(questions, (data, key) => {
						const { type, question, answer } = data;

						if (type === 'separator') {
							return <div class={s.separator}>{question}</div>;
						}

						return (
							<Question
								key={key}
								question={question && <HTML markdown content={question} class={question} />}
								answer={answer}
								isOpen={this.state.activeKey === key}
								toggleActive={() => this.changeActiveKey(key)}
							/>
						);
					})}
				</div>
				{this.renderOverlayedContent()}
			</div>
		);
	}
}